export default function trackAnalyticEvent(eventName, options) {
  if (window._satellite !== undefined && typeof window._satellite.track === 'function') {
    window._satellite.track(eventName, options);
  } else {
    console.info("Cannot track event, tracking library not loaded.", { eventName, options })
  }
}
